module.exports = __webpack_public_path__ + "media/application/images/ui/nav-group-arrow-7966260ade44fea2299987ae82b5ee84.svg";